module.exports = {
  dateConditions: [
    { label: "Is", value: "is" },
    { label: "Is Not", value: "is-not" },
    { label: "Is Empty", value: "is-empty" },
    { label: "Is Not Empty", value: "is-not-empty" },
    { label: "Before", value: "before" },
    { label: "After", value: "after" },
    { label: "Between", value: "between" },
  ],
  numberComponent: [
    { label: "Is", value: "is" },
    { label: "Is Not", value: "is-not" },
    { label: "Is Empty", value: "is-empty" },
    { label: "Is Not Empty", value: "is-not-empty" },
    { label: "Less Than", value: "less-than" },
    { label: "Greater Than", value: "greater-than" },
    { label: "Less Than or Equal", value: "less-than-or-equal" },
    { label: "Greater Than or Equal", value: "greater-than-or-equal" },
  ],
  stringConditions: [
    { label: "Is", value: "is" },
    { label: "Is Not", value: "is-not" },
    { label: "Is Empty", value: "is-empty" },
    { label: "Is Not Empty", value: "is-not-empty" },
    { label: "Starts With", value: "starts-with" },
    { label: "Ends With", value: "ends-with" },
    // { label: "Like", value: "like" },
    { label: "Not Contains", value: "not-contains" },
    { label: "Contains", value: "contains" },
  ],
  dropdownConditions: [
    { label: "Is", value: "is" },
    { label: "Is Not", value: "is-not" },
    { label: "Is Empty", value: "is-empty" },
    { label: "Is Not Empty", value: "is-not-empty" },
  ],
  statusComponent: [
    { label: "Shipped", value: "shipped" },
    { label: "Processing", value: "processing" },
    { label: "Delivered", value: "delivered" },
  ],
  StatusComponent: [
    { label: "Shipped", value: "shipped" },
    { label: "Processing", value: "processing" },
    { label: "Delivered", value: "delivered" },
  ],
  dateComponent: [
    { label: "Is", value: "is" },
    { label: "Is Not", value: "is-not" },
    { label: "Is Empty", value: "is-empty" },
    { label: "Is Not Empty", value: "is-not-empty" },
    { label: "Before", value: "before" },
    { label: "After", value: "after" },
    { label: "Between", value: "between" },
  ],
  stringComponent: [
    { label: "Is", value: "is" },
    { label: "Is Not", value: "is-not" },
    { label: "Is Empty", value: "is-empty" },
    { label: "Is Not Empty", value: "is-not-empty" },
    { label: "Starts With", value: "starts-with" },
    { label: "Ends With", value: "ends-with" },
    { label: "Not Contains", value: "not-contains" },
    { label: "Contains", value: "contains" },
  ],
  stockComponent: [
    { label: "Available", value: "available" },
    { label: "Out of Stock", value: "out-of-stock" },
    { label: "Low Stock", value: "low-stock" },
  ],
  PurOrdersComponent: [
    { label: "Delivered", value: "delivered" },
    { label: "Delayed", value: "delayed" },
    { label: "Shipped", value: "shipped" },
  ],
  contactOwnerOptions: [
    { value: "22106000006841842", label: "Test Lead Owner" },
  ],

  leadType: [
    { value: "domestic", label: "🟢 Domestic" },
    { value: "export", label: "🔵 Export" },
  ],

  countries: [
    { value: "afghanistan", label: "Afghanistan" },
    { value: "albania", label: "Albania" },
    { value: "algeria", label: "Algeria" },
    { value: "andorra", label: "Andorra" },
    { value: "angola", label: "Angola" },
    { value: "antigua_and_barbuda", label: "Antigua and Barbuda" },
    { value: "argentina", label: "Argentina" },
    { value: "armenia", label: "Armenia" },
    { value: "australia", label: "Australia" },
    { value: "austria", label: "Austria" },
    { value: "azerbaijan", label: "Azerbaijan" },
    { value: "bahamas", label: "Bahamas" },
    { value: "bahrain", label: "Bahrain" },
    { value: "bangladesh", label: "Bangladesh" },
    { value: "barbados", label: "Barbados" },
    { value: "belarus", label: "Belarus" },
    { value: "belgium", label: "Belgium" },
    { value: "belize", label: "Belize" },
    { value: "benin", label: "Benin" },
    { value: "bhutan", label: "Bhutan" },
    { value: "bolivia", label: "Bolivia" },
    { value: "bosnia_and_herzegovina", label: "Bosnia and Herzegovina" },
    { value: "botswana", label: "Botswana" },
    { value: "brazil", label: "Brazil" },
    { value: "brunei", label: "Brunei" },
    { value: "bulgaria", label: "Bulgaria" },
    { value: "burkina_faso", label: "Burkina Faso" },
    { value: "burundi", label: "Burundi" },
    { value: "cabo_verde", label: "Cabo Verde" },
    { value: "cambodia", label: "Cambodia" },
    { value: "cameroon", label: "Cameroon" },
    { value: "canada", label: "Canada" },
    { value: "central_african_republic", label: "Central African Republic" },
    { value: "chad", label: "Chad" },
    { value: "chile", label: "Chile" },
    { value: "china", label: "China" },
    { value: "colombia", label: "Colombia" },
    { value: "comoros", label: "Comoros" },
    { value: "congo_brazzaville", label: "Congo (Brazzaville)" },
    { value: "congo_kinshasa", label: "Congo (Kinshasa)" },
    { value: "costa_rica", label: "Costa Rica" },
    { value: "cote_divoire", label: "Côte d’Ivoire" },
    { value: "croatia", label: "Croatia" },
    { value: "cuba", label: "Cuba" },
    { value: "cyprus", label: "Cyprus" },
    { value: "czech_republic", label: "Czech Republic" },
    { value: "denmark", label: "Denmark" },
    { value: "djibouti", label: "Djibouti" },
    { value: "dominica", label: "Dominica" },
    { value: "dominican_republic", label: "Dominican Republic" },
    { value: "ecuador", label: "Ecuador" },
    { value: "egypt", label: "Egypt" },
    { value: "el_salvador", label: "El Salvador" },
    { value: "equatorial_guinea", label: "Equatorial Guinea" },
    { value: "eritrea", label: "Eritrea" },
    { value: "estonia", label: "Estonia" },
    { value: "eswatini", label: "Eswatini" },
    { value: "ethiopia", label: "Ethiopia" },
    { value: "fiji", label: "Fiji" },
    { value: "finland", label: "Finland" },
    { value: "france", label: "France" },
    { value: "gabon", label: "Gabon" },
    { value: "gambia", label: "Gambia" },
    { value: "georgia", label: "Georgia" },
    { value: "germany", label: "Germany" },
    { value: "ghana", label: "Ghana" },
    { value: "greece", label: "Greece" },
    { value: "grenada", label: "Grenada" },
    { value: "guatemala", label: "Guatemala" },
    { value: "guinea", label: "Guinea" },
    { value: "guinea_bissau", label: "Guinea-Bissau" },
    { value: "guyana", label: "Guyana" },
    { value: "haiti", label: "Haiti" },
    { value: "honduras", label: "Honduras" },
    { value: "hungary", label: "Hungary" },
    { value: "iceland", label: "Iceland" },
    { value: "india", label: "India" },
    { value: "indonesia", label: "Indonesia" },
    { value: "iran", label: "Iran" },
    { value: "iraq", label: "Iraq" },
    { value: "ireland", label: "Ireland" },
    { value: "israel", label: "Israel" },
    { value: "italy", label: "Italy" },
    { value: "jamaica", label: "Jamaica" },
    { value: "japan", label: "Japan" },
    { value: "jordan", label: "Jordan" },
    { value: "kazakhstan", label: "Kazakhstan" },
    { value: "kenya", label: "Kenya" },
    { value: "kiribati", label: "Kiribati" },
    { value: "kosovo", label: "Kosovo" },
    { value: "kuwait", label: "Kuwait" },
    { value: "kyrgyzstan", label: "Kyrgyzstan" },
    { value: "laos", label: "Laos" },
    { value: "latvia", label: "Latvia" },
    { value: "lebanon", label: "Lebanon" },
    { value: "lesotho", label: "Lesotho" },
    { value: "liberia", label: "Liberia" },
    { value: "libya", label: "Libya" },
    { value: "liechtenstein", label: "Liechtenstein" },
    { value: "lithuania", label: "Lithuania" },
    { value: "luxembourg", label: "Luxembourg" },
    { value: "madagascar", label: "Madagascar" },
    { value: "malawi", label: "Malawi" },
    { value: "malaysia", label: "Malaysia" },
    { value: "maldives", label: "Maldives" },
    { value: "mali", label: "Mali" },
    { value: "malta", label: "Malta" },
    { value: "marshall_islands", label: "Marshall Islands" },
    { value: "mauritania", label: "Mauritania" },
    { value: "mauritius", label: "Mauritius" },
    { value: "mexico", label: "Mexico" },
    { value: "micronesia", label: "Micronesia" },
    { value: "moldova", label: "Moldova" },
    { value: "monaco", label: "Monaco" },
    { value: "mongolia", label: "Mongolia" },
    { value: "montenegro", label: "Montenegro" },
    { value: "morocco", label: "Morocco" },
    { value: "mozambique", label: "Mozambique" },
    { value: "myanmar", label: "Myanmar" },
    { value: "namibia", label: "Namibia" },
    { value: "nauru", label: "Nauru" },
    { value: "nepal", label: "Nepal" },
    { value: "netherlands", label: "Netherlands" },
    { value: "new_zealand", label: "New Zealand" },
    { value: "nicaragua", label: "Nicaragua" },
    { value: "niger", label: "Niger" },
    { value: "nigeria", label: "Nigeria" },
    { value: "north_korea", label: "North Korea" },
    { value: "north_macedonia", label: "North Macedonia" },
    { value: "norway", label: "Norway" },
    { value: "oman", label: "Oman" },
    { value: "pakistan", label: "Pakistan" },
    { value: "palau", label: "Palau" },
    { value: "palestine", label: "Palestine" },
    { value: "panama", label: "Panama" },
    { value: "papua_new_guinea", label: "Papua New Guinea" },
    { value: "paraguay", label: "Paraguay" },
    { value: "peru", label: "Peru" },
    { value: "philippines", label: "Philippines" },
    { value: "poland", label: "Poland" },
    { value: "portugal", label: "Portugal" },
    { value: "qatar", label: "Qatar" },
    { value: "romania", label: "Romania" },
    { value: "russia", label: "Russia" },
    { value: "rwanda", label: "Rwanda" },
    { value: "saint_kitts_and_nevis", label: "Saint Kitts and Nevis" },
    { value: "saint_lucia", label: "Saint Lucia" },
    {
      value: "saint_vincent_and_grenadines",
      label: "Saint Vincent and the Grenadines",
    },
    { value: "samoa", label: "Samoa" },
    { value: "san_marino", label: "San Marino" },
    { value: "sao_tome_and_principe", label: "São Tomé and Príncipe" },
    { value: "saudi_arabia", label: "Saudi Arabia" },
    { value: "senegal", label: "Senegal" },
    { value: "serbia", label: "Serbia" },
    { value: "seychelles", label: "Seychelles" },
    { value: "sierra_leone", label: "Sierra Leone" },
    { value: "singapore", label: "Singapore" },
    { value: "slovakia", label: "Slovakia" },
    { value: "slovenia", label: "Slovenia" },
    { value: "solomon_islands", label: "Solomon Islands" },
    { value: "somalia", label: "Somalia" },
    { value: "south_africa", label: "South Africa" },
    { value: "south_korea", label: "South Korea" },
    { value: "south_sudan", label: "South Sudan" },
    { value: "spain", label: "Spain" },
    { value: "sri_lanka", label: "Sri Lanka" },
    { value: "sudan", label: "Sudan" },
    { value: "suriname", label: "Suriname" },
    { value: "sweden", label: "Sweden" },
    { value: "switzerland", label: "Switzerland" },
    { value: "syria", label: "Syria" },
    { value: "taiwan", label: "Taiwan" },
    { value: "tajikistan", label: "Tajikistan" },
    { value: "tanzania", label: "Tanzania" },
    { value: "thailand", label: "Thailand" },
    { value: "timor_leste", label: "Timor-Leste" },
    { value: "togo", label: "Togo" },
    { value: "tonga", label: "Tonga" },
    { value: "trinidad_and_tobago", label: "Trinidad and Tobago" },
    { value: "tunisia", label: "Tunisia" },
    { value: "turkey", label: "Turkey" },
    { value: "turkmenistan", label: "Turkmenistan" },
    { value: "tuvalu", label: "Tuvalu" },
    { value: "uganda", label: "Uganda" },
    { value: "ukraine", label: "Ukraine" },
    { value: "united_arab_emirates", label: "United Arab Emirates" },
    { value: "united_kingdom", label: "United Kingdom" },
    { value: "united_states", label: "United States" },
    { value: "uruguay", label: "Uruguay" },
    { value: "uzbekistan", label: "Uzbekistan" },
    { value: "vanuatu", label: "Vanuatu" },
    { value: "vatican_city", label: "Vatican City" },
    { value: "venezuela", label: "Venezuela" },
    { value: "vietnam", label: "Vietnam" },
    { value: "yemen", label: "Yemen" },
    { value: "zambia", label: "Zambia" },
    { value: "zimbabwe", label: "Zimbabwe" },
  ],
  leadSource: [
    { value: "", label: "-None-" },
    { value: "Website", label: "Website" },
    { value: "Facebook", label: "Facebook" },
    { value: "Instagram", label: "Instagram" },
    { value: "Outdoor Campaign", label: "Outdoor Campaign" },
    { value: "Online Campaign", label: "Online Campaign" },
    { value: "Walkthrough Gallery", label: "Walkthrough Gallery" },
  ],
  leadsource: [
    { value: "", label: "-None-" },
    { value: "Website", label: "Website" },
    { value: "Facebook", label: "Facebook" },
    { value: "Instagram", label: "Instagram" },
    { value: "Outdoor Campaign", label: "Outdoor Campaign" },
    { value: "Online Campaign", label: "Online Campaign" },
    { value: "Walkthrough Gallery", label: "Walkthrough Gallery" },
  ],
  leadComponent: [
    { value: "Open", label: "Open" },
    { value: "Pending From Client", label: "Pending From Client" },
    { value: "Qualified", label: "Qualified" },
    { value: "Converted to Deal", label: "Converted to Deal" },
    { value: "Unqualified", label: "Unqualified" },
  ],

  orderNum: [
    { value: "ORD1", label: "🟢 ORD 1" },
    { value: "ORD2", label: "🟡 ORD 2" },
    { value: "ORD3", label: "🔵 ORD 3" },
  ],
  dealtype: [
    { value: "domestic", label: "🟢 Domestic" },
    { value: "export", label: "🔵 Export" },
  ],
  dealStatusOptions: [
    {
      value: "deal_created",
      label: "Deal Created",
      optionStyling:
        "bg-blue-100 text-blue-800 border-1 border-blue-800 rounded-md ",
    },
    {
      value: "walkthrough_created",
      label: "Walkthrough Created",
      optionStyling:
        "bg-cyan-100 text-cyan-800 border-1 border-cyan-800 rounded-md ",
    },
    {
      value: "walkthrough_followup_1",
      label: "Walkthrough Follow Up 1",
      optionStyling:
        "bg-orange-100 text-orange-800 border-1 border-orange-800 rounded-md ",
    },
    {
      value: "walkthrough_followup_2",
      label: "Walkthrough Follow Up 2",
      optionStyling:
        "bg-orange-100 text-orange-800 border-1 border-orange-800 rounded-md ",
    },
    {
      value: "walkthrough_followup_3",
      label: "Walkthrough Follow Up 3",
      optionStyling:
        "bg-orange-100 text-orange-800 border-1 border-orange-800 rounded-md ",
    },
    {
      value: "walkthrough_completed",
      label: "Walkthrough Completed",
      optionStyling:
        "bg-teal-100 text-teal-800 border-1 border-teal-800 rounded-md ",
    },
    {
      value: "quote_created",
      label: "Quote Created",
      optionStyling:
        "bg-purple-100 text-purple-800 border-1 border-purple-800 rounded-md ",
    },
    {
      value: "quote_sent",
      label: "Quote Sent",
      optionStyling:
        "bg-indigo-100 text-indigo-800 border-1 border-indigo-800 rounded-md ",
    },
    {
      value: "quote_followup_1",
      label: "Quote Follow Up 1",
      optionStyling:
        "bg-yellow-100 text-yellow-800 border-1 border-yellow-800 rounded-md ",
    },
    {
      value: "quote_followup_2",
      label: "Quote Follow Up 2",
      optionStyling:
        "bg-yellow-100 text-yellow-800 border-1 border-yellow-800 rounded-md ",
    },
    {
      value: "quote_followup_3",
      label: "Quote Follow Up 3",
      optionStyling:
        "bg-yellow-100 text-yellow-800 border-1 border-yellow-800 rounded-md ",
    },
    {
      value: "quote_followup_4",
      label: "Quote Follow Up 4",
      optionStyling:
        "bg-yellow-100 text-yellow-800 border-1 border-yellow-800 rounded-md ",
    },
    {
      value: "quote_followup_5",
      label: "Quote Follow Up 5",
      optionStyling:
        "bg-yellow-100 text-yellow-800 border-1 border-yellow-800 rounded-md ",
    },
    {
      value: "quote_rejected",
      label: "Quote Rejected",
      optionStyling:
        "bg-red-100 text-red-800 border-1 border-red-800 rounded-md ",
    },
    {
      value: "quote_revised",
      label: "Quote Revised",
      optionStyling:
        "bg-orange-100 text-orange-800 border-1 border-orange-800 rounded-md ",
    },
    {
      value: "quote_resent",
      label: "Quote Resent",
      optionStyling:
        "bg-purple-100 text-purple-800 border-1 border-purple-800 rounded-md ",
    },
    {
      value: "revised_followup_1",
      label: "Revised Quote Follow Up 1",
      optionStyling:
        "bg-orange-100 text-orange-800 border-1 border-orange-800 rounded-md ",
    },
    {
      value: "revised_followup_2",
      label: "Revised Quote Follow Up 2",
      optionStyling:
        "bg-orange-100 text-orange-800 border-1 border-orange-800 rounded-md ",
    },
    {
      value: "deal_closed",
      label: "Deal Closed",
      optionStyling:
        "bg-green-100 text-green-800 border-1 border-green-800 rounded-md ",
    },
    {
      value: "closed_lost",
      label: "Closed Lost",
      optionStyling:
        "bg-red-100 text-red-800 border-1 border-red-800 rounded-md ",
    },
  ],
  customertype: [
    { value: "Architect", label: "🟢 Architect" },
    { value: "Dealer", label: "🟠 Dealer" },
    { value: "End Customer", label: "🔵 End Customer" },
  ],
  blindType: [
    { value: "Zebra With Pelmate", label: "Zebra With Pelmate" },
    { value: "Zebra Without Pelmate", label: "Zebra Without Pelmate" },
    { value: "Roller With Pelmate", label: "Roller With Pelmate" },
    { value: "Roller Without Pelmate", label: "Roller Without Pelmate" },
  ],
  accessories: [
    { value: "Black", label: "Black" },
    { value: "White", label: "White" },
    { value: "silver", label: "Silver" },
  ],
  dealowner: [{ value: "22106000006841842", label: "Test Deal User" }],

  company: [
    { value: "Company A", label: "Company A" },
    { value: "Company B", label: "Company B" },
    { value: "Company C", label: "Company C" },
  ],
  preferredTransportation: [
    { value: "Air", label: "Air" },
    { value: "Sea", label: "Sea" },
    { value: "Road", label: "Road" },
    { value: "Courier", label: "Courier" },
  ],
  blogCategory: [
    { value: "Window Blinds", label: "Window Blinds" },
    { value: "3D WallPaper", label: "3D WallPaper" },
  ],

  motorization: [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
  ],

  motorType: [
    { value: "Brused Dc Motor ", label: "Brused Dc Motor " },
    { value: "Permanent Magnet DC Motor", label: "Permanent Magnet DC Motor" },
  ],

  mechanismColour: [
    { value: "White", label: "White" },
    { value: "Steel", label: "Steel" },
    { value: "Brass", label: "Brass" },
  ],
  sideofControl: [
    { value: "Left", label: "Left" },
    { value: "Right", label: "Right" },
  ],
  unit: [
    { value: "mm", label: "mm" },
    { value: "cm", label: "cm" },
    { value: "inches", label: "inches" },
  ],
  teammember: [{ value: "22106000006841842", label: "Walkthrough Member 1" }],
  accountName: [
    { value: "Trigya", label: "Trigya Innovation Pvt Ltd" },
    { value: "Beta Corporation", label: "Beta Corporation Pvt Ltd" },
  ],
  payment: [
    { value: "Credit", label: "Credit" },
    { value: "Cash On Delivery", label: "Cash On Delivery" },
    { value: "Advance", label: "Advance" },
  ],
  stockStatus: [
    { value: "In Stock", label: "In Stock" },
    { value: "Out Stock", label: "Out Stock" },
  ],
  quoteStatus: [
    { value: "Closed", label: "Closed" },
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
    { value: "Pending", label: "Pending" },
  ],
  purchaseStatus: [
    { value: "All", label: "All" },
    { value: "Draft", label: "Draft" },
    { value: "Aproved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
    { value: "Pending", label: "Pending" },
    {
      value: "partiallyPurchaseReceived",
      label: "Partially Purchase Received",
    },
    { value: "PO Closed", label: "PO Closed" },
  ],
  quoteType: [
    { value: "Domestic", label: "Domestic" },
    { value: "Export", label: "Export" },
  ],
  columnFormulationType: [
    { value: "Raw Material", label: "Raw Material" },
    { value: "Mechanism", label: "Mechanism" },
  ],
  organisation: [
    { value: "Umbrona", label: "Umbrona" },
    { value: "Wintree", label: "Wintree" },
  ],
  Quotationvalidity: [
    { value: "15 Days", label: "15 Days" },
    { value: "30 Days", label: "30 Days" },
    { value: "60 Days", label: "60 Days" },
  ],
  taskOwner: [
    { value: "Sumit", label: "Sumit" },
    { value: "Gagan", label: "Gagan" },
    { value: "Puneet", label: "Puneet" },
  ],
  taskStatus: [
    {
      value: "completed",
      label: "Completed",
      optionStyling:
        "bg-green-100 text-green-800 border-1 border-green-800 rounded-md ",
    },
    {
      value: "pending",
      label: "Pending",
      optionStyling:
        "bg-yellow-100 text-yellow-800 border-1 border-yellow-800 rounded-md ",
    },
    {
      value: "progress",
      label: "Progress",
      optionStyling:
        "bg-purple-100 text-purple-800 border-1 border-purple-800 rounded-md ",
    },
  ],
  taskRate: [
    { value: "0", label: "0%" },
    { value: "5", label: "5%" },
    { value: "12", label: "12%" },
    { value: "18", label: "18%" },
    { value: "28", label: "28%" },
  ],
  reviewStatus: [
    {
      value: "unapproved",
      label: "Unapproved",
      optionStyling:
        "bg-red-100 text-red-800 border-1 border-red-800 rounded-md ",
    },
    {
      value: "approved",
      label: "Approved",
      optionStyling:
        "bg-green-100 text-green-800 border-1 border-green-800 rounded-md ",
    },
  ],
  paymentStatus: [
    {
      value: "Paid",
      label: "Paid",
      optionStyling:
        "bg-green-100 text-green-700 border-1 border-green-300 rounded-md ",
    },
    {
      value: "Pending",
      label: "Pending",
      optionStyling:
        "bg-yellow-100 text-yellow-700 border-1 border-yellow-300 rounded-md ",
    },
    {
      value: "Partially Paid",
      label: "Partially Paid",
      optionStyling:
        "bg-purple-100 text-purple-800 border-1 border-purple-800 rounded-md ",
    },
  ],
  OrderStatusoptions: [
    {
      value: "completed",
      label: "Completed",
      optionStyling:
        "bg-green-100 text-green-700 border-1 border-green-300 rounded-md ",
    },
    {
      value: "progress",
      label: "In Progress",
      optionStyling:
        "bg-orange-100 text-orange-700 border-1 border-orange-300 rounded-md ",
    },
    {
      value: "pending",
      label: "Pending",
      optionStyling:
        "bg-yellow-100 text-yellow-700 border-1 border-yellow-300 rounded-md ",
    },
  ],

  leadsts: [
    {
      value: "Open",
      label: "Open",
      optionStyling:
        "bg-blue-100 text-blue-800 border-1 border-blue-800 rounded-md",
    },
    {
      value: "Pending From Client",
      label: "Pending From Client",
      optionStyling:
        "bg-amber-100 text-amber-800 border-1 border-amber-800 rounded-md",
    },
    {
      value: "Qualified",
      label: "Qualified",
      optionStyling:
        "bg-orange-100 text-orange-800 border-1 border-orange-800 rounded-md",
    },
    {
      value: "Converted to Deal",
      label: "Converted to Deal",
      optionStyling:
        "bg-green-100 text-green-800 border-1 border-green-800 rounded-md",
    },
    {
      value: "Unqualified",
      label: "Unqualified",
      optionStyling:
        "bg-red-100 text-red-800 border-1 border-red-800 rounded-md",
    },
    {
      value: "Attempted to Contact",
      label: "Attempted to Contact",
      optionStyling:
        "bg-amber-100 text-amber-800 border-1 border-amber-800 rounded-md",
    },
    {
      value: "Contacted",
      label: "Contacted",
      optionStyling:
        "bg-teal-100 text-teal-800 border-1 border-teal-800 rounded-md",
    },
    {
      value: "Future Target",
      label: "Future Target",
      optionStyling:
        "bg-purple-100 text-purple-800 border-1 border-purple-800 rounded-md",
    },
    {
      value: "Lost Lead",
      label: "Lost Lead",
      optionStyling:
        "bg-gray-200 text-gray-800 border-1 border-gray-800 rounded-md",
    },
    {
      value: "Junk Lead",
      label: "Junk Lead",
      optionStyling:
        "bg-gray-100 text-gray-800 border-1 border-gray-800 rounded-md",
    },
  ],

  priority: [
    { value: "High", label: "High" },
    { value: "Medium", label: "Medium" },
    { value: "Low", label: "Low" },
  ],
  leadOwner: [{ value: "22106000006841842", label: "Test User" }],

  CompanyOptions: [
    { value: "22106000007300830", label: "Test Company" },
    { value: "Company A", label: "Company A" },
    { value: "Company B", label: "Company B" },
  ],

  taskOwner: [{ value: "22106000006841842", label: "Task Owner" }],

  walkthroughOwner1: [
    { value: "22106000006841842", label: "Walkthrough Owner" },
  ],

  testCompany: [{ value: "22106000007300830", label: "Test Company" }],

  testContact: [{ value: "22106000007297468", label: "Test Client" }],

  leadStatus: [
    {
      value: "",
      label: "⚪ -None-",
      optionStyling:
        "bg-gray-100 text-gray-600 border border-gray-400 rounded-md",
    },

    {
      value: "Open",
      label: "🔵 Open",
      optionStyling:
        "bg-blue-100 text-blue-800 border border-blue-800 rounded-md",
    },

    {
      value: "Pending From Client",
      label: "🟡 Pending From Client",
      optionStyling:
        "bg-yellow-100 text-yellow-800 border border-yellow-800 rounded-md",
    },

    {
      value: "Qualified",
      label: "🔶 Qualified",
      optionStyling:
        "bg-teal-100 text-teal-800 border border-teal-800 rounded-md",
    },

    {
      value: "Converted to Deal",
      label: "🟢 Converted to Deal",
      optionStyling:
        "bg-green-100 text-green-800 border border-green-800 rounded-md",
    },

    {
      value: "Unqualified",
      label: "🔴 Unqualified",
      optionStyling: "bg-red-100 text-red-800 border border-red-800 rounded-md",
    },

    {
      value: "Attempted to Contact",
      label: "🟠 Attempted to Contact",
      optionStyling:
        "bg-orange-100 text-orange-800 border border-orange-800 rounded-md",
    },

    {
      value: "Contacted",
      label: "🟠 Contacted",
      optionStyling:
        "bg-orange-200 text-orange-900 border border-orange-900 rounded-md",
    },

    {
      value: "Create Walkthrough",
      label: "🔴 Create Walkthrough",
      optionStyling:
        "bg-rose-100 text-rose-800 border border-rose-800 rounded-md",
    },

    {
      value: "Future Target",
      label: "🟣 Future Target",
      optionStyling:
        "bg-purple-100 text-purple-800 border border-purple-800 rounded-md",
    },

    {
      value: "Lost Lead",
      label: "🔴 Lost Lead",
      optionStyling: "bg-red-200 text-red-900 border border-red-900 rounded-md",
    },

    {
      value: "Junk Lead",
      label: "⚪ Junk Lead",
      optionStyling:
        "bg-gray-200 text-gray-700 border border-gray-500 rounded-md",
    },
  ],

  // Category Options
  categoryOptions: [
    { value: "22106000007724816", label: "Window Blinds" },
    // { value: "22106000007727908", label: "Category 2" },
  ],

  // Sub Category Options
  subCategoryOptions: [
    { value: "22106000007736632", label: "Roller Blinds" },
    { value: "22106000007762174", label: "Zebra Blinds" },
  ],

  // Unit Options
  unitOptions: [
    { value: "cm", label: "Centimeter" },
    { value: "inch", label: "Inches" },
    { value: "mm", label: "Millimeter" },
  ],

  itemUnitOptions: [
    { value: "cm", label: "Centimeter" },
    { value: "inch", label: "Inches" },
    { value: "mm", label: "Millimeter" },
    { value: "sqft", label: "Square Feet " },
    { value: "sqmtr", label: "Square Meter " },
  ],
  rawMaterialUnitOptions: [
    { value: "cm", label: "Centimeter" },
    { value: "inch", label: "Inches" },
    { value: "mm", label: "Millimeter" },
    { value: "mtr", label: "Meter" },
    { value: "sqft", label: "Square Feet " },
    { value: "sqmtr", label: "Square Meter " },
    { value: "ft", label: "Feet " },
    { value: "pcs", label: "Pieces" },
    { value: "box", label: "Box" },
    { value: "set", label: "Set" },
  ],
  itemMechanismOptions: [
    {
      value: "Roller Blinds With Pelmate",
      label: "Roller Blinds With Pelmate",
    },
    {
      value: "Roller Blinds Without Pelmate",
      label: "Roller Blinds Without Pelmate",
    },
    { value: "Zebra Blinds With Pelmate", label: "Zebra Blinds With Pelmate" },
    {
      value: "Zebra Blinds Without Pelmate",
      label: "Zebra Blinds Without Pelmate",
    },
  ],

  taxOptions: [
    { value: "0", label: "0%" },
    { value: "5", label: "5%" },
    { value: "12", label: "12%" },
    { value: "18", label: "18%" },
    { value: "28", label: "28%" },
  ],

  // Sales Account Options
  salesAccountOptions: [
    { value: "domestic_sales", label: "Domestic Sales" },
    { value: "export_sales", label: "Export Sales" },
    { value: "online_sales", label: "Online Sales" },
    { value: "retail_sales", label: "Retail Sales" },
  ],

  // Purchase Account Options
  purchaseAccountOptions: [
    { value: "raw_material_purchase", label: "Raw Material Purchase" },
    { value: "finished_goods_purchase", label: "Finished Goods Purchase" },
    { value: "import_purchase", label: "Import Purchase" },
    { value: "local_vendor_purchase", label: "Local Vendor Purchase" },
  ],

  // Inventory Account Options
  inventoryAccountOptions: [
    { value: "raw_material_inventory", label: "Raw Material Inventory" },
    { value: "finished_goods_inventory", label: "Finished Goods Inventory" },
    {
      value: "work_in_progress_inventory",
      label: "Work in Progress Inventory",
    },
  ],

  // Preferred Vendor Options
  preferredVendorOptions: [
    { value: "sunshade_fabrics", label: "Sunshade Fabrics Pvt. Ltd." },
    { value: "bright_blinds", label: "Bright Blinds & Co." },
    { value: "eco_window_tech", label: "Eco Window Technologies" },
    { value: "urban_curtains", label: "Urban Curtains & Blinds" },
  ],
  vendorOptions: [
    { value: "sunshade_fabrics", label: "Sunshade Fabrics Pvt. Ltd." },
    { value: "bright_blinds", label: "Bright Blinds & Co." },
    { value: "eco_window_tech", label: "Eco Window Technologies" },
    { value: "urban_curtains", label: "Urban Curtains & Blinds" },
  ],

  // Warehouse Name Options
  warehouseNameOptions: [
    { value: "main_warehouse", label: "Main Warehouse" },
    { value: "east_unit", label: "East Unit" },
    { value: "west_unit", label: "West Unit" },
    { value: "online_dispatch", label: "Online Dispatch Center" },
  ],

  columnOptions: [
    { value: "1", label: "1 Column" },
    { value: "2", label: "2 Columns" },
    { value: "3", label: "3 Columns" },
    { value: "4", label: "4 Columns" },
  ],
  gstTreatment: [
    { value: "Registered", label: "Registered" },
    { value: "Unregistered", label: "Unregistered" },
  ],
  productType: [
    { value: "Zebra Blinds", label: "Zebra Blinds" },
    { value: "Roller Blinds", label: "Roller Blinds" },
    { value: "Wooden Blinds", label: "Wooden Blinds" },
    { value: "Vertical Blinds", label: "Vertical Blinds" },
  ],
  blindName: [
    { value: "Zebra Blinds", label: "Zebra Blinds" },
    { value: "Roller Blinds", label: "Roller Blinds" },
    { value: "Wooden Blinds", label: "Wooden Blinds" },
    { value: "Vertical Blinds", label: "Vertical Blinds" },
  ],
  city: [
    { value: "amritsar", label: "Amritsar" },
    { value: "ludhiana", label: "Ludhiana" },
    { value: "jalandhar", label: "Jalandhar" },
    { value: "patiala", label: "Patiala" },
    { value: "bathinda", label: "Bathinda" },
    { value: "mohali", label: "Mohali" },
    { value: "hoshiarpur", label: "Hoshiarpur" },
    { value: "moga", label: "Moga" },
    { value: "fazilka", label: "Fazilka" },
    { value: "barnala", label: "Barnala" },
    { value: "pathankot", label: "Pathankot" },
    { value: "kapurthala", label: "Kapurthala" },
    { value: "sangrur", label: "Sangrur" },
    { value: "firozpur", label: "Firozpur" },
  ],
  // walkthroughOwner:[
  //   {value:"walkthroughowner1",label:"Walkthrough Owner 1"},
  //   {value:"walkthroughowner2",label:"Walkthrough Owner 2"},
  //   {value:"walkthroughowner3",label:"Walkthrough Owner 3"},
  // ],
  client: [
    { value: "clientA", label: "Client A" },
    { value: "clientB", label: "Client B" },
    { value: "clientC", label: "Client C" },
    { value: "clientD", label: "Client D" },
  ],
  customerName: [
    { value: "CustomerA", label: "Customer A" },
    { value: "CustomerB", label: "Customer B" },
    { value: "CustomerC", label: "Customer C" },
  ],
  partyName: [
    { value: "CustomerA", label: "Customer A" },
    { value: "CustomerB", label: "Customer B" },
    { value: "CustomerC", label: "Customer C" },
  ],
  motorId: [
    { value: "Brused Dc Motor ", label: "Brused Dc Motor " },
    { value: "Permanent Magnet DC Motor", label: "Permanent Magnet DC Motor" },
  ],
  shadeNumber: [{ value: "22106000007801632", label: "Shade 1" }],
  shade: [
    { value: "Light Filtering", label: "Light Filtering" },
    { value: "Blackout", label: "Blackout" },
    { value: "Solar Screen", label: "Solar Screen" },
  ],
  orderSource: [
    { value: "b2b", label: "B2B" },
    { value: "b2c", label: "B2C" },
  ],
  moduleName: [
    { value: "quote", label: "Quote" },
    { value: "bill", label: "Bill" },
    { value: "sales", label: "Sales" },
  ],
  leadstatus: [
    { value: "Open", label: "Open" },
    { value: "Pending From Client", label: "Pending From Client" },
    { value: "Qualified", label: "Qualified" },
    { value: "Converted to Deal", label: "Converted to Deal" },
    { value: "Unqualified", label: "Unqualified" },
    { value: "Attempted to Contact", label: "Attempted to Contact" },
    { value: "Contacted", label: "Contacted" },
    { value: "Future Target", label: "Future Target" },
    { value: "Lost Lead", label: "Lost Lead" },
    { value: "Junk Lead", label: "Junk Lead" },
  ],

  isTypeRequiredOptions: [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ],

  taskModule: [
    { value: "lead", label: "Lead" },
    { value: "deal", label: "Deal" },
    { value: "client", label: "Client" },
    { value: "company", label: "Company" },
    { value: "walkthrough", label: "Walkthrough" },
    { value: "quotation", label: "Quotation" },
  ],

  category: [
    { value: "window_blinds", label: "Window Blinds" },
    { value: "3d_wallpaper", label: "3D WallPaper" },
  ],
  subCategory: [
    { value: "roller_blinds", label: "Roller Blinds" },
    { value: "zebra_blinds_Pelmet", label: "Zebra Blinds With Pelmet" },
    {
      value: "zebra_blinds_WithoutPelmet",
      label: "Zebra Blinds Without Pelmet",
    },
    { value: "Roller_blinds_Pelmet", label: "Roller Blinds With Pelmet" },
    {
      value: "Roller_blinds_WithoutPelmet",
      label: "Roller Blinds Without Pelmet",
    },
  ],
  materialRequisitionNo: [
    { value: "MR-2024-001", label: "MR-2024-001" },
    { value: "MR-2024-002", label: "MR-2024-002" },
    { value: "MR-2024-003", label: "MR-2024-003" },
    { value: "MR-2024-004", label: "MR-2024-004" },
    { value: "MR-2024-005", label: "MR-2024-005" },
    { value: "MR-2024-006", label: "MR-2024-006" },
    { value: "MR-2024-007", label: "MR-2024-007" },
    { value: "MR-2024-008", label: "MR-2024-008" },
    { value: "MR-2024-009", label: "MR-2024-009" },
    { value: "MR-2024-010", label: "MR-2024-010" },
  ],

  statusOptions: [
    { value: "Pending", label: "Pending" },
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
    { value: "In Progress", label: "In Progress" },
    { value: "Completed", label: "Completed" },
    { value: "On Hold", label: "On Hold" },
  ],
  QuoteStatusOptions: [
    {
      value: "draft",
      label: "Draft",
      optionStyling:
        "bg-gray-100 text-gray-800 border-1 border-gray-800 rounded-md ",
    },
    {
      value: "sent",
      label: "Sent",
      optionStyling:
        "bg-blue-100 text-blue-800 border-1 border-blue-800 rounded-md ",
    },
    {
      value: "Approved",
      label: "Approved",
      optionStyling:
        "bg-green-100 text-green-800 border-1 border-green-800 rounded-md ",
    },
    {
      value: "Rejected",
      label: "Rejected",
      optionStyling:
        "bg-red-100 text-red-800 border-1 border-red-800 rounded-md ",
    },
  ],

  jobWorkNumbers: [
    { value: "JW-2024-045", label: "JW-2024-045" },
    { value: "JW-2024-012", label: "JW-2024-012" },
    { value: "JW-2024-078", label: "JW-2024-078" },
    { value: "JW-2024-031", label: "JW-2024-031" },
    { value: "JW-2024-099", label: "JW-2024-099" },
    { value: "JW-2024-056", label: "JW-2024-056" },
    { value: "JW-2024-022", label: "JW-2024-022" },
    { value: "JW-2024-087", label: "JW-2024-087" },
    { value: "JW-2024-034", label: "JW-2024-034" },
    { value: "JW-2024-011", label: "JW-2024-011" },
  ],

  requestedBy: [
    { value: "John Smith", label: "John Smith" },
    { value: "Sarah Johnson", label: "Sarah Johnson" },
    { value: "Michael Chen", label: "Michael Chen" },
    { value: "Emily Davis", label: "Emily Davis" },
    { value: "Robert Wilson", label: "Robert Wilson" },
    { value: "Lisa Thompson", label: "Lisa Thompson" },
    { value: "David Rodriguez", label: "David Rodriguez" },
    { value: "Jennifer Lee", label: "Jennifer Lee" },
    { value: "Thomas Brown", label: "Thomas Brown" },
    { value: "Amanda Wilson", label: "Amanda Wilson" },
  ],
  dates: [
    { value: "2024-01-15", label: "2024-01-15" },
    { value: "2024-01-18", label: "2024-01-18" },
    { value: "2024-01-20", label: "2024-01-20" },
    { value: "2024-01-22", label: "2024-01-22" },
    { value: "2024-01-25", label: "2024-01-25" },
    { value: "2024-01-28", label: "2024-01-28" },
    { value: "2024-01-30", label: "2024-01-30" },
    { value: "2024-02-01", label: "2024-02-01" },
    { value: "2024-02-03", label: "2024-02-03" },
    { value: "2024-02-05", label: "2024-02-05" },
  ],

  item: [
    { value: "roller_blinds", label: "Roller Blinds" },
    { value: "zebra_blinds_Pelmet", label: "Zebra Blinds With Pelmet" },
    {
      value: "zebra_blinds_WithoutPelmet",
      label: "Zebra Blinds Without Pelmet",
    },
  ],
  jobWorkNum: [
    { value: "JW001", label: "JW 001" },
    { value: "JW002", label: "JW 002" },
    { value: "JW003", label: "JW 003" },
  ],
  productionStage: [
    { value: "channelCutting", label: "Channel Cutting" },
    { value: "FabricOrWoodenCutting", label: "Fabric/Wooden cutting" },
    { value: "assembly", label: "Assembly" },
    { value: "qc", label: "QC" },
    { value: "packing", label: "Packing" },
    { value: "dispatch", label: "Dispatch" },
    { value: "printing", label: "Printing" },
  ],
  label: [
    // { value: "Width MM", label: " Width MM" },
    // { value: "Drop MM", label: "Drop MM" },
    { value: "STD Pelmet", label: "STD Pelmet" },
    { value: "Roller top MM", label: "Roller top MM" },
    { value: "Round Bottom MM", label: "Round Bottom MM" },
    { value: "Triangle Botom MM", label: "Triangle Botom MM" },
    { value: "FAB Width", label: "FAB  Width" },
    { value: "FAB Drop", label: "FAB  Drop" },
    { value: "No. of Bracktes", label: "No. of Bracktes" },
    { value: "Fabric Used Sq.mtr", label: "Fabric Used Sq.mtr" },
    { value: "Area of Blinds Sq.mtr", label: "Area of Blinds Sq.mtr" },
    { value: "Flat Bottom", label: "Flat Bottom" },
    { value: "Chain Drop", label: "Chain Drop" },
    { value: "qty", label: "Quantity" },
  ],

  shiftOptions: [
    { value: "9AM-6PM", label: "9AM to 6pm" },
    { value: "7AM-8PM", label: "7AM to 8PM" },
    { value: "night-shift", label: "Night Shift" },
  ],

  BooleanStatus: [
    {
      value: true,
      label: "Yes",
      optionStyling:
        "bg-green-100 text-green-800 border-1 border-green-800 rounded-md",
    },
    {
      value: false,
      label: "No",
      optionStyling:
        "bg-red-100 text-red-800 border-1 border-red-800 rounded-md",
    },
  ],
  MRSStatusOptions: [
    {
      value: "In Stock",
      label: "In Stock",
      optionStyling:
        "bg-green-100 text-green-800 border-1 border-green-800 rounded-md",
    },
    {
      value: "Need to Request",
      label: "Need to Request",
      optionStyling:
        "bg-red-100 text-red-800 border-1 border-red-800 rounded-md",
    },
    {
      value: "Not Required",
      label: "Not Required",
      optionStyling:
        "bg-gray-100 text-gray-800 border-1 border-gray-800 rounded-md",
    },
    {
      value: "In Transit",
      label: "In Transit",
      optionStyling:
        "bg-yellow-100 text-yellow-800 border-1 border-yellow-800 rounded-md",
    },
  ],
  PlanStatus: [
    {
      value: "Overloaded",
      label: "Overloaded",
      optionStyling: "bg-red-100 text-red-700 border border-red-700 rounded-md",
    },
    {
      value: "Perfect",
      label: "Perfect",
      optionStyling:
        "bg-green-100 text-green-700 border border-green-700 rounded-md",
    },
    {
      value: "Healthy",
      label: "Healthy",
      optionStyling:
        "bg-teal-100 text-teal-700 border border-teal-700 rounded-md",
    },
    {
      value: "Weak",
      label: "Weak",
      optionStyling:
        "bg-orange-100 text-orange-700 border border-orange-700 rounded-md",
    },
    {
      value: "—",
      label: "—",
      optionStyling:
        "bg-gray-100 text-gray-500 border border-gray-500 rounded-md",
    },
  ],
};

module.exports.dateComponent = module.exports.dateConditions;
module.exports.stringComponent = module.exports.stringConditions;
module.exports.StatusComponent = module.exports.statusComponent;
module.exports.leadstatus = module.exports.leadStatus;
module.exports.leadsource = module.exports.leadSource;
module.exports.motorId = module.exports.motorType;
module.exports.partyName = module.exports.customerName;
module.exports.CompanyOptions = module.exports.company;
module.exports.taskRate = module.exports.numberComponent;
module.exports.leadComponent = module.exports.leadStatus;
